import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../../Contexts/AuthContext";

const UserRoute = ({ children }) => {
  console.log("user route");
  let location = useLocation();
  const { isLoggedin } = useAuthContext();

  if (!isLoggedin) {
    return <Navigate to={"/login"} replace state={{ from: location }} />;
  } else return children;
};

export default UserRoute;
